import * as React from 'react';
import * as _ from 'lodash';
import $ from 'jquery';
import { StepsFn } from './NewFeatureOverlay.js';
import { Steps } from './NewFeatureOverlay.js';
import { groupNameByMeta } from './NewFeatureReducer.js';
import { DisplayLogicComparisonOptions } from './NewFeatureOverlay.js';
import { DisplayLogicActionOptions } from './NewFeatureOverlay.js';
import { GetTextFromDDLByValue } from './NewFeatureOverlay.js';
import { resolve } from 'path';
import CheckBox from '../../PageLayout/CheckBox';
import CheckBox3State from '../../Generic/checkBox3State';
import DropDown from '../../Generic/dropDown2';
import { UIDropDown } from '../../Generic/dropDown';
import Dropzone from 'react-dropzone';
import { getSizedThumbnailUrl } from './../../../utilities/helpers';
import { RadioList } from './../../Generic/radioList';
import * as misc from './../../../misc';
import { getAvailableFilters } from './NewFeatureFilters.js';
import NewFeatureOverlayComplexLogicStep from './NewFeatureOverlayComplexLogicStep.js';
import NewFeatureOverlayBundledFeaturesStep from './NewFeatureOverlayBundledFeaturesStep.js';
export default function () {
    function onClick1(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        $('.ui-breadcrumbs-container').scrollLeft($('.ui-breadcrumbs-container').scrollLeft() - 50);
    }
    function onClick2(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, step, stepIndex) {
        setStep(step, !!this.props.edit);
    }
    function repeatStep3(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, step, stepIndex) {
        return [(!step.adminOnly || this.props.AR.isSiteAdmin(true)) && (!hasUnlinkedData || step.unlinkedVisible) ? React.createElement('li', {
                'className': getLinkClass(step),
                'onClick': onClick2.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, step, stepIndex),
                'key': '26231'
            }, '\r\n              ', step.text, ' ', step.step === 1 && this.getNeededFiltersConditions().length ? React.createElement('span', {
                'className': 'red',
                'key': '2907'
            }, ' *') : null) : null];
    }
    function onClick4(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        $('.ui-breadcrumbs-container').scrollLeft($('.ui-breadcrumbs-container').scrollLeft() + 50);
    }
    function onChange5(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        updateStateValue('name', e);
    }
    function onChange6(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        updateStateValue('sku', e);
    }
    function onChange7(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        updateStateValue('model', e);
    }
    function onChange8(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        updateStateValue('description', e);
    }
    function onChange9(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        updateStateValue('subDescription', e);
    }
    function onKeyDown10(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        this.autosize();
    }
    function onClick11(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.setState({ showUnitDDL: true });
    }
    function onClickOutside12(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.setState({ showUnitDDL: false });
    }
    function onSelect13(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, val) {
        this.setState({
            showUnitDDL: false,
            unit: val
        });
    }
    function onChecked14(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleStateKey('kitchen', 'enableVisualizer');
    }
    function onChecked15(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleStateKey('kitchen', 'enableQuotingTool');
    }
    function onChecked16(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleStateKey('bathroom', 'enableVisualizer');
    }
    function onChecked17(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleStateKey('bathroom', 'enableQuotingTool');
    }
    function onSelect18(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, multiple, value, values) {
        this.handleSelection(value, values);
    }
    function scopeMultiple19(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        var multiple = !this.props.group.name.toLowerCase().includes('vanity');
        return React.createElement('div', {
            'className': 'feature-creation__aside-footer-sub-group',
            'key': '9560'
        }, React.createElement('div', { 'className': 'feature-creation__aside-footer-sub-group-header' }, !multiple ? 'As' : 'With', ': ', React.createElement('span', { 'className': 'hint' }, 'Choose ', multiple ? '1 or More' : '1')), React.createElement(RadioList, {
            'items': this.getMetaCustomCompleteItems(),
            'onSelect': onSelect18.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, multiple),
            'multiple': multiple
        }));
    }
    function onChecked20(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.setState({ metaFixtureOff: !this.state.metaFixtureOff });
    }
    function onSelect21(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, multiple, value, values) {
        this.handleSelection(value, values);
    }
    function scopeMultiple22(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        var multiple = this.props.group.name.toLowerCase().includes('sink') || this.props.group.name.toLowerCase().includes('faucet');
        return React.createElement('div', {
            'className': 'feature-creation__aside-footer-sub-group',
            'key': '10687'
        }, React.createElement('div', { 'className': 'feature-creation__aside-footer-sub-group-header' }, 'Size: ', React.createElement('span', { 'className': 'hint' }, 'Choose ', multiple ? 'Any' : '1')), React.createElement(RadioList, {
            'items': this.getMetaSizeItems(),
            'onSelect': onSelect21.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, multiple),
            'multiple': multiple,
            'allowNone': multiple
        }));
    }
    function onChecked23(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleStateKey('fireplace', 'enableVisualizer');
    }
    function onChecked24(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleStateKey('fireplace', 'enableQuotingTool');
    }
    function onChecked25(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleStateKey('laundryroom', 'enableVisualizer');
    }
    function onChecked26(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleStateKey('laundryroom', 'enableQuotingTool');
    }
    function onChecked27(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('hideUnitLabel');
    }
    function onChecked28(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('productNotForSale');
    }
    function onChecked29(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('employeesOnly');
    }
    function onChecked30(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('hideQuantity');
    }
    function onChecked31(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('autoAddToCart');
    }
    function onChecked32(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('notTaxable');
    }
    function onChecked33(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('useStonePricing');
    }
    function onChecked34(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('priceEditable');
    }
    function onChange35(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        this.setState({ defaultQuantity: e.target.value });
    }
    function onClick36(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex) {
        this.handleUpdateInstallation(installation, 'showDDL', true);
    }
    function onClickOutside37(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex) {
        this.handleUpdateInstallation(installation, 'showDDL', false);
    }
    function onSelect38(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex, val) {
        {
            this.handleUpdateInstallation(installation, 'fabricatorInstallation_id', val);
            this.handleUpdateInstallation(installation, 'showDDL', false);
        }
    }
    function onClick39(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex) {
        this.handleDeleteInstallation(installation);
    }
    function repeatInstallation40(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex) {
        return [React.createElement('li', {
                'className': 'fc-inst',
                'key': installationIndex
            }, React.createElement('div', { 'className': 'select2 fc-inst__select ' + (installation.showDDL ? 'select2--active' : '') }, React.createElement('div', {
                'className': 'select2-value',
                'onClick': onClick36.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex)
            }, '\r\n                    ', installation.selected.text, '\r\n                  '), installation.showDDL ? React.createElement(DropDown, {
                'selected': installation.selected.value,
                'items': this.props.installationDDL,
                'onClickOutside': onClickOutside37.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex),
                'onSelect': onSelect38.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex),
                'key': '16470'
            }) : null), React.createElement('div', { 'className': 'fc-inst__remove' }, React.createElement('button', {
                'className': 'ui-icon-remove2',
                'onClick': onClick39.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, installation, installationIndex)
            })))];
    }
    function onClick41(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, item, itemIndex) {
        this.setState({ selectedFilterCategory: item });
    }
    function repeatItem42(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, item, itemIndex) {
        return [item.values && item.values.length > 0 ? React.createElement('li', {
                'className': 'fc-cat__list-item ' + (this.filterGroupHasFilters(item) ? 'fc-cat__list-item--has-filters' : '') + '\r\n                     ' + (this.state.selectedFilterCategory == item ? 'fc-cat__list-item--active' : ''),
                'onClick': onClick41.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, item, itemIndex),
                'key': '175141'
            }, item.name, ' ', this.getNeededFiltersConditions().includes(item.name.trim()) ? React.createElement('span', {
                'className': 'red',
                'style': { marginLeft: '3px' },
                'key': '18043'
            }, ' *') : null) : null];
    }
    function onChange43(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        this.handleSearchFiltersTextChange(e.target.value);
    }
    function onClick44(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.handleSearchFiltersTextChange('');
    }
    function onChecked45(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, item, itemIndex) {
        this.handleToggleFilter(item);
    }
    function repeatItem46(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, item, itemIndex) {
        return [React.createElement('li', {
                'className': 'fc-filters__list-item',
                'key': '193821'
            }, React.createElement(CheckBox3State, {
                'type': 'tiny',
                'state': this.getCheckFilterState(item),
                'text': item.displayText,
                'onChecked': onChecked45.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, item, itemIndex),
                'disabled': this.isDefaultFilter(item)
            }))];
    }
    function onChecked47(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.setState({ galleryEnabled: !this.state.galleryEnabled });
    }
    function onClick48(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, image, imageIndex) {
        this.handleSetFeatured(image);
    }
    function onClick49(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, image, imageIndex) {
        this.handleMakeDefault(image);
    }
    function onClick50(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, image, imageIndex) {
        this.handleDeleteGalleryImage(image);
    }
    function repeatImage51(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, image, imageIndex) {
        return [React.createElement('li', {
                'className': 'fc-gallery__list-item',
                'key': '220621'
            }, React.createElement('span', {
                'className': 'ui-house fc-gallery__list-item-house ' + (image.featured ? 'ui-house--active' : ''),
                'onClick': onClick48.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, image, imageIndex)
            }, 'Featured'), React.createElement('div', {
                'className': 'fc-gallery__list-item-image',
                'style': { backgroundImage: 'url(\'' + getSizedThumbnailUrl(image.url, 150, true) + '\')' }
            }), React.createElement('span', {
                'className': 'ui-star fc-gallery__list-item-star ' + (image.default ? 'ui-star--active' : ''),
                'onClick': onClick49.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, image, imageIndex)
            }, image.default ? '' : 'Make ', 'Default'), React.createElement('button', {
                'className': 'ui-icon-remove2 fc-gallery__list-item-remove',
                'onClick': onClick50.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, image, imageIndex)
            }))];
    }
    function onChange52(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, e) {
        this.setState({ complexLogic: e.target.value });
    }
    function onChecked53(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        this.toggleSetting('displayLogicEnabled');
    }
    function onClick54(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, actionText) {
        this.setState({ displayLogicActionDDLVisible: true });
    }
    function onClickOutside55(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, actionText) {
        this.setState({ displayLogicActionDDLVisible: false });
    }
    function onSelect56(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, actionText, val) {
        this.handleUpdateDisplayLogicAction(val);
    }
    function scopeActionText57(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        var actionText = GetTextFromDDLByValue(DisplayLogicActionOptions, this.state.displayLogicAction);
        return React.createElement('div', { 'className': 'fc-logic__header-right' }, React.createElement('div', { 'className': 'fc-inst__select select2 ' + (this.state.displayLogicActionDDLVisible ? 'select2--active' : '') }, React.createElement('div', {
            'className': 'select2-value',
            'onClick': onClick54.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, actionText)
        }, '\r\n                  ', actionText, '\r\n                '), this.state.displayLogicActionDDLVisible ? React.createElement(DropDown, {
            'selected': this.state.displayLogicAction,
            'items': DisplayLogicActionOptions,
            'onClickOutside': onClickOutside55.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, actionText),
            'onSelect': onSelect56.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, actionText),
            'useVirtualizedList': true,
            'filter': false,
            'key': '24441'
        }) : null), React.createElement('span', { 'className': 'generic-popup-title' }, actionText, ' if all the below options are true'));
    }
    function onClick58(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, formatDisplayText) {
        this.handleUpdateDisplayRule(displayRule, 'showDDL', true);
    }
    function onClickOutside59(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, formatDisplayText, e) {
        this.handleUpdateDisplayRule(displayRule, 'showDDL', false);
    }
    function onSelect60(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, formatDisplayText, val) {
        this.handleUpdateDisplayRuleComparisonFor(displayRule, val);
    }
    function scopeFormatDisplayText61(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor) {
        var formatDisplayText = text => _.trim(text.substring(text.indexOf('-') + 1));
        return React.createElement('div', { 'className': 'fc-logic__list-item-cell fc-logic__list-item-cell--name' }, React.createElement('div', { 'className': 'fc-inst__select select2 ' + (displayRule.showDDL ? 'select2--active' : '') }, React.createElement('div', {
            'className': 'select2-value',
            'onClick': onClick58.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, formatDisplayText)
        }, '\r\n                      ', formatDisplayText(comparisonFor.text), '\r\n                    '), displayRule.showDDL ? React.createElement(DropDown, {
            'selected': comparisonFor.value,
            'sort': false,
            'wide': true,
            'items': this.state.featureList,
            'useVirtualizedList': true,
            'onClickOutside': onClickOutside59.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, formatDisplayText),
            'onSelect': onSelect60.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, formatDisplayText),
            'key': '26074'
        }) : null));
    }
    function onClick62(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor) {
        this.handleUpdateDisplayRule(displayRule, 'showComparisonDDL', true);
    }
    function onClickOutside63(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, e) {
        this.handleUpdateDisplayRule(displayRule, 'showComparisonDDL', false);
    }
    function onSelect64(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, val) {
        this.handleUpdateDisplayRuleComparison(displayRule, val);
    }
    function onChange65(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor, e) {
        this.handleUpdateDisplayRule(displayRule, 'value', e.target.value);
    }
    function onClick66(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor) {
        this.handleDeleteDisplayRule(displayRule);
    }
    function scopeComparisonFor67(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex) {
        var comparisonFor = displayRule.comparisonFor || {
            text: 'Material',
            value: '-1'
        };
        return React.createElement('li', {
            'className': 'fc-logic__list-item',
            'key': '253031'
        }, scopeFormatDisplayText61.apply(this, [
            isServerData,
            setStep,
            getLinkClass,
            updateStateValue,
            hasKitchenSub,
            hasBathroomSub,
            hasFireplaceSub,
            hasLaundryRoomSub,
            hasUnlinkedData,
            displayRule,
            displayRuleIndex,
            comparisonFor
        ]), React.createElement('div', { 'className': 'fc-logic__list-item-cell fc-logic__list-item-cell--value' }, React.createElement('div', { 'className': 'fc-inst__select select2 ' + (displayRule.showComparisonDDL ? 'select2--active' : '') }, React.createElement('div', {
            'className': 'select2-value',
            'onClick': onClick62.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor)
        }, '\r\n                      ', displayRule.comparison.value, '\r\n                    '), displayRule.showComparisonDDL ? React.createElement(DropDown, {
            'selected': displayRule.comparison.value,
            'items': DisplayLogicComparisonOptions,
            'onClickOutside': onClickOutside63.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor),
            'onSelect': onSelect64.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor),
            'useVirtualizedList': true,
            'filter': false,
            'key': '27147'
        }) : null)), React.createElement('div', { 'className': 'fc-logic__list-item-cell fc-logic__list-item-cell--input' }, React.createElement('input', {
            'type': 'text',
            'disabled': displayRule.comparison.value === 'wizard',
            'className': 'ui-input margin-b0 text-center ' + (displayRule.comparison.value === 'wizard' ? 'ui-input--disabled' : 'ui-input--blue'),
            'value': displayRule.value,
            'onChange': onChange65.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor)
        })), React.createElement('div', { 'className': 'fc-logic__list-item-cell fc-logic__list-item-cell--remove' }, React.createElement('button', {
            'className': 'ui-icon-remove2',
            'onClick': onClick66.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex, comparisonFor)
        })));
    }
    function repeatDisplayRule68(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, displayRule, displayRuleIndex) {
        return [scopeComparisonFor67.apply(this, [
                isServerData,
                setStep,
                getLinkClass,
                updateStateValue,
                hasKitchenSub,
                hasBathroomSub,
                hasFireplaceSub,
                hasLaundryRoomSub,
                hasUnlinkedData,
                displayRule,
                displayRuleIndex
            ])];
    }
    function onChange69(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, assocFeature, assocFeatureIndex, e) {
        this.updateAssocFeatureProp(assocFeature.id, 'cost', misc.toNumber(e.target.value));
    }
    function onChecked70(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, assocFeature, assocFeatureIndex, value) {
        this.updateAssocFeatureProp(assocFeature.id, 'unlocked', value);
    }
    function repeatAssocFeature71(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, assocFeature, assocFeatureIndex) {
        return React.createElement('li', {
            'className': 'fc-layer',
            'key': assocFeature.id
        }, React.createElement('div', { 'className': 'fc-layer-cell fc-layer-cell--title' }, '\r\n                ', groupNameByMeta(assocFeature), '\r\n              '), React.createElement('div', { 'className': 'fc-layer-cell fc-layer-cell--price' }, React.createElement('input', {
            'type': 'text',
            'className': 'generic-popup-textbox',
            'value': assocFeature.cost,
            'onChange': onChange69.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, assocFeature, assocFeatureIndex)
        })), React.createElement('div', { 'className': 'fc-layer-cell fc-layer-cell--checkbox' }, React.createElement('div', { 'className': 'ui-svg-checkbox ui-svg-checkbox--gray' }, React.createElement(CheckBox, {
            'checked': !assocFeature.unlocked,
            'onChecked': onChecked70.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, assocFeature, assocFeatureIndex)
        }))));
    }
    function onClick72(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF, group, groupIndex) {
        this.setRfState({ activeGroup: group }, this.refreshFilterIcons);
    }
    function repeatGroup73(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF, group, groupIndex) {
        return [React.createElement('li', {
                'className': 'fc-cat__list-item ' + (group === RF.activeGroup ? 'fc-cat__list-item--active' : ''),
                'onClick': onClick72.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF, group, groupIndex),
                'key': '309161'
            }, group.name, '\r\n                  ')];
    }
    function onChange74(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF, e) {
        this.setRfState({ productFilter: e.target.value });
    }
    function onClick75(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF) {
        !_.isEmpty(RF.allFilterOptions) && this.setRfState({
            allFilterOptionsVisible: true,
            sortOptionsVisible: false,
            materialFilterOptionsVisible: false,
            colorFilterOptionsVisible: false
        });
    }
    function onClick76(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF) {
        !_.isEmpty(RF.materialFilterOptions) && this.setRfState({
            materialFilterOptionsVisible: true,
            sortOptionsVisible: false,
            colorFilterOptionsVisible: false,
            allFilterOptionsVisible: false
        });
    }
    function onClick77(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF) {
        this.setRfState({
            sortOptionsVisible: true,
            materialFilterOptionsVisible: false,
            colorFilterOptionsVisible: false,
            allFilterOptionsVisible: false
        });
    }
    function onClick78(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF) {
        !_.isEmpty(RF.colorFilterOptions) && this.setRfState({
            colorFilterOptionsVisible: true,
            sortOptionsVisible: false,
            materialFilterOptionsVisible: false,
            allFilterOptionsVisible: false
        });
    }
    function onChecked79(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF) {
        this.allProductsClicked(this.state.relatedFeatures);
    }
    function onChecked80(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF, feature, featureIndex, selectedFeatures) {
        this.toggleFeature(feature.id, feature);
    }
    function scopeSelectedFeatures81(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF, feature, featureIndex) {
        var selectedFeatures = RF.features;
        return [React.createElement('li', {
                'className': 'fc-filters__list-item',
                'key': '350701'
            }, React.createElement(CheckBox, {
                'type': 'tiny',
                'text': feature.originalNakedName || feature.name,
                'checked': selectedFeatures.some(sf => feature.id.indexOf(sf) !== -1),
                'onChecked': onChecked80.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF, feature, featureIndex, selectedFeatures)
            }))];
    }
    function repeatFeature82(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF, feature, featureIndex, selectedFeatures) {
        return scopeSelectedFeatures81.apply(this, [
            isServerData,
            setStep,
            getLinkClass,
            updateStateValue,
            hasKitchenSub,
            hasBathroomSub,
            hasFireplaceSub,
            hasLaundryRoomSub,
            hasUnlinkedData,
            RF,
            feature,
            featureIndex
        ]);
    }
    function scopeRF83(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        var RF = this.state.relatedFeatures;
        return React.createElement('div', {
            'className': 'feature-creation__content',
            'key': '30228'
        }, React.createElement('div', { 'className': 'fc-filter fc-filter--related' }, React.createElement('div', { 'className': 'fc-cat' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Product Groups'), this.state.relatedLoading ? React.createElement('div', {
            'style': {
                width: '100%',
                height: '100%',
                margin: '0',
                padding: '0',
                position: 'absolute',
                zIndex: '2000'
            },
            'key': '30561'
        }, React.createElement('div', { 'className': 'ui-loader' })) : null, React.createElement.apply(this, [
            'ul',
            { 'className': 'fc-cat__list' },
            _.map(this.props.unfilteredFeatureGroups, repeatGroup73.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF))
        ])), React.createElement('div', { 'className': 'fc-filters fc-filters--with-header' }, React.createElement('div', { 'className': 'fc-filters__header' }, React.createElement('div', { 'className': 'fc-filters__header-input' }, React.createElement('input', {
            'className': 'generic-popup-textbox',
            'placeholder': 'search',
            'value': RF.productFilter,
            'onChange': onChange74.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF)
        })), React.createElement('div', { 'className': 'fc-filters__header-buttons' }, React.createElement('span', {
            'className': 'ui-icon-filter ui-icon-filter--properties ' + (RF.allFilterOptionsVisible ? 'ui-icon-filter--active' : '') + '\r\n                        ' + (_.isEmpty(RF.allFilterOptions) ? 'disabled' : ''),
            'onClick': onClick75.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF)
        }, '\r\n                    +Filters\r\n                  '), React.createElement('span', {
            'className': 'ui-icon-filter ui-icon-filter--material ' + (RF.materialFilterOptionsVisible ? 'ui-icon-filter--active' : '') + '\r\n                  ' + (_.isEmpty(RF.materialFilterOptions) ? 'disabled' : ''),
            'onClick': onClick76.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF)
        }, '\r\n                    Material\r\n                  '), React.createElement('span', {
            'className': 'ui-icon-filter ui-icon-filter--' + RF.productSortBy.toLowerCase() + '\r\n                      ' + (RF.sortOptionsVisible ? 'ui-icon-filter--active' : ''),
            'onClick': onClick77.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF)
        }, '\r\n                    ', RF.productSortBy, '\r\n                  '), React.createElement('span', {
            'className': 'ui-icon-filter ui-icon-filter--color ' + (RF.colorFilterOptionsVisible ? 'ui-icon-filter--active' : '') + '\r\n                        ' + (_.isEmpty(RF.colorFilterOptions) ? 'disabled' : ''),
            'onClick': onClick78.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF)
        }, '\r\n                    Color\r\n                  '))), React.createElement('div', { 'className': 'fc-filters__sub-header' }, React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': RF.checkAllFeatures,
            'text': 'All Products',
            'disabled': !RF.activeGroup,
            'onChecked': onChecked79.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF)
        })), !RF.activeGroup ? React.createElement('div', {
            'className': 'fc-filters__text',
            'key': '34410'
        }, React.createElement('div', { 'className': 'fc-installation__empty' }, '\r\n                  Select a Product Group\r\n                ')) : null, RF.activeGroup && _.isEmpty(RF.activeGroup.features || RF.activeGroup.values) ? React.createElement('div', {
            'className': 'fc-filters__text',
            'key': '34622'
        }, React.createElement('div', { 'className': 'fc-installation__empty' }, '\r\n                  Product Group has no Products, it should not have been visible\r\n                ')) : null, RF.activeGroup && !_.isEmpty(RF.activeGroup.features || RF.activeGroup.values) ? React.createElement.apply(this, [
            'ul',
            {
                'className': 'fc-filters__list',
                'key': '34936'
            },
            _.map(this.applyProductSort(this.applyProductFilters(this.getGroupsFeatures(RF.activeGroup))), repeatFeature82.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, RF))
        ]) : null)));
    }
    function onChange84(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, feature, featureIndex, e) {
        this.updateGroupedFeatureByNameProp(feature.id, 'cost', misc.toNumber(e.target.value));
    }
    function onChecked85(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, feature, featureIndex, value) {
        this.updateGroupedFeatureByNameProp(feature.id, 'unlocked', value);
    }
    function repeatFeature86(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, feature, featureIndex) {
        return React.createElement('li', {
            'className': 'fc-layer',
            'key': feature.id
        }, React.createElement('div', { 'className': 'fc-layer-cell fc-layer-cell--title' }, '\r\n                ', groupNameByMeta(feature), '\r\n              '), React.createElement('div', { 'className': 'fc-layer-cell fc-layer-cell--price' }, React.createElement('input', {
            'type': 'text',
            'className': 'generic-popup-textbox',
            'value': feature.cost,
            'onChange': onChange84.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, feature, featureIndex)
        })), React.createElement('div', { 'className': 'fc-layer-cell fc-layer-cell--checkbox' }, React.createElement('div', { 'className': 'ui-svg-checkbox ui-svg-checkbox--gray' }, React.createElement(CheckBox, {
            'checked': !feature.unlocked,
            'onChecked': onChecked85.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, feature, featureIndex)
        }))));
    }
    function onClick87(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, canSave, canNext, canBack) {
        canBack && this.setState({ step: this.getPrevStep(this.state.step) });
    }
    function onClick88(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, canSave, canNext, canBack) {
        canSave && this.handleSave();
    }
    function onClick89(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, canSave, canNext, canBack) {
        canNext && this.setState({ step: this.getNextStep(this.state.step) });
    }
    function scopeCanSaveCanNextCanBack90(isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData) {
        var canSave = this.state.canSave;
        var canNext = this.state.step.step < Steps.GroupedFeaturesByName.step;
        var canBack = this.state.step.step > Steps.Installation.step;
        return React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', { 'className': 'ui-button ui-button--blue ui-button--small ' + (!canBack ? 'disabled' : '') + ' push-right-180' }, React.createElement('span', {
            'className': 'ui-button-text ui-button--uppercase',
            'onClick': onClick87.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, canSave, canNext, canBack)
        }, 'Back')), React.createElement('button', { 'className': 'ui-button ui-button--blue ui-button--small' }, React.createElement('span', {
            'className': 'ui-button-text ui-button--uppercase',
            'onClick': this.props.onCancel
        }, 'Cancel')), React.createElement('button', { 'className': 'ui-button ui-button--green ' + (!canSave ? 'disabled' : '') }, React.createElement('span', {
            'className': 'ui-button-text ui-button--uppercase',
            'onClick': onClick88.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, canSave, canNext, canBack)
        }, 'Save')), React.createElement('button', { 'className': 'ui-button ui-button--blue ui-button--small ' + (!canNext ? 'disabled' : '') }, React.createElement('span', {
            'className': 'ui-button-text ui-button--uppercase',
            'onClick': onClick89.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData, canSave, canNext, canBack)
        }, 'Next')));
    }
    function scopeIsServerDataSetStepGetLinkClassUpdateStateValueHasKitchenSubHasBathroomSubHasFireplaceSubHasLaundryRoomSubHasUnlinkedData91() {
        var isServerData = this.props.isServerData;
        var setStep = step => this.setState({ step }, this.checkCanSave);
        var getLinkClass = step => `ui-breadcrumbs-link${ this.state.step.step === step.step ? ' ui-breadcrumbs-link--active' : '' }`;
        var updateStateValue = (key, e) => this.setState({ [key]: e.target ? e.target.value : e }, this.checkCanSave);
        var hasKitchenSub = this.props.hasKitchen;
        var hasBathroomSub = this.props.hasBathroom;
        var hasFireplaceSub = this.props.hasFireplace;
        var hasLaundryRoomSub = this.props.hasLaundryRoom;
        var hasUnlinkedData = this.props.hasUnlinkedData;
        return React.createElement('div', { 'className': 'ui-popup ui-popup--large' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, this.props.edit ? 'Editing ' + this.state.name : 'New Product Feature Setup')), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'ui-breadcrumbs-container' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'ui-breadcrumbs ui-breadcrumbs--1100' },
            React.createElement('li', {
                'className': 'navigation-left',
                'onClick': onClick1.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
                'dangerouslySetInnerHTML': { __html: '&laquo' }
            }),
            _.map(StepsFn(this.props.edit), repeatStep3.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)),
            React.createElement('li', {
                'className': 'navigation-right',
                'onClick': onClick4.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
                'dangerouslySetInnerHTML': { __html: '&raquo' }
            })
        ])), React.createElement('div', { 'className': 'feature-creation' }, React.createElement('aside', { 'className': 'feature-creation__aside scrollable-list' }, this.state.nameError ? React.createElement('div', {
            'className': 'feature-creation__aside-error',
            'key': '3373'
        }, this.state.nameError) : null, React.createElement('div', { 'className': 'feature-creation__aside-block' }, React.createElement('span', { 'className': 'generic-popup-title' }, '\r\n            Product Name\r\n            ', !this.state.name ? React.createElement('span', {
            'className': 'red',
            'key': '3612'
        }, ' *') : null), React.createElement('input', {
            'className': 'generic-popup-textbox',
            'placeholder': 'Product Name',
            'maxLength': 255,
            'value': this.state.name,
            'onChange': onChange5.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        })), !hasUnlinkedData ? React.createElement('div', {
            'className': 'feature-creation__aside-block',
            'key': '3889'
        }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Sku Number'), React.createElement('input', {
            'className': 'generic-popup-textbox',
            'placeholder': 'Sku',
            'maxLength': 32,
            'value': this.state.sku,
            'onChange': onChange6.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        })) : null, !hasUnlinkedData ? React.createElement('div', {
            'className': 'feature-creation__aside-block',
            'key': '4214'
        }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Model Number'), React.createElement('input', {
            'type': 'text',
            'className': 'generic-popup-textbox',
            'placeholder': 'Model',
            'maxLength': 64,
            'value': this.state.model,
            'onChange': onChange7.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        })) : null, this.state.descError ? React.createElement('div', {
            'className': 'feature-creation__aside-error',
            'key': '4559'
        }, this.state.descError) : null, !hasUnlinkedData ? React.createElement('div', {
            'className': 'feature-creation__aside-block',
            'key': '4669'
        }, React.createElement('span', { 'className': 'generic-popup-title' }, '\r\n            Description\r\n            ', !this.state.description && this.props.categoriesVisualizer !== 'leadform' ? React.createElement('span', {
            'className': 'red',
            'key': '4822'
        }, ' *') : null), React.createElement('textarea', {
            'className': 'generic-popup-textarea',
            'placeholder': 'Description',
            'maxLength': 750,
            'value': this.state.description,
            'onChange': onChange8.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        })) : null, !hasUnlinkedData ? React.createElement('div', {
            'className': 'feature-creation__aside-block',
            'key': '5189'
        }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Sub Description'), React.createElement('div', { 'className': 'generic-popup-textarea' }, React.createElement('div', { 'className': 'generic-popup-textarea--line-markers' }, React.createElement('textarea', {
            'value': this.state.subDescription,
            'ref': node => this.autoSizeTextArea = node,
            'maxLength': 500,
            'onChange': onChange9.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'onKeyDown': onKeyDown10.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        })))) : null, this.state.thumbError ? React.createElement('div', {
            'className': 'feature-creation__aside-error',
            'key': '5776'
        }, this.state.thumbError) : null, !hasUnlinkedData ? React.createElement(Dropzone, {
            'accept': 'image/jpeg, image/png, image/svg+xml',
            'onDrop': this.onDrop,
            'className': 'feature-creation__aside-thumbnail',
            'acceptStyle': {
                'boxShadow': '0 0 1em green inset',
                'backgroundColor': 'rgba(0,192,0,0.3)'
            },
            'rejectStyle': {
                'boxShadow': '0 0 1em red inset',
                'backgroundColor': 'rgba(192,0,0,0.3)'
            },
            'key': '5888'
        }, this.state.thumbnailImageUrl ? [
            React.createElement('span', {
                'className': 'generic-popup-title',
                'key': '62951'
            }, 'Update Visualizer Image Thumbnail'),
            React.createElement('div', {
                'className': 'feature-creation__aside-thumbnail-image',
                'style': { backgroundImage: 'url(\'' + this.state.thumbnailImageUrl + '\')' },
                'key': '62953'
            })
        ] : null, !this.state.thumbnailImageUrl && this.props.categoriesVisualizer !== 'leadform' ? [
            React.createElement('span', {
                'className': 'generic-popup-title',
                'key': '66241'
            }, '\r\n              Add Visualizer Image Thumbnail\r\n              ', React.createElement('span', { 'className': 'red' }, ' *')),
            React.createElement('div', {
                'className': 'feature-creation__aside-thumbnail-image',
                'key': '66243'
            })
        ] : null, React.createElement('span', { 'className': 'generic-popup-title' }, 'Drag and Drop Files'), React.createElement('div', { 'className': 'feature-creation__aside-thumbnail-subtitle-subtext' }, 'Supported File Formats: JPG, PNG and SVG')) : null, !hasUnlinkedData ? React.createElement('div', {
            'className': 'feature-creation__aside-block',
            'key': '7207'
        }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Measurement Units'), React.createElement('div', { 'className': 'fc-inst__select select2 ' + (this.state.showUnitDDL ? 'select2--active' : '') }, React.createElement('div', {
            'className': 'select2-value',
            'onClick': onClick11.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        }, '\r\n              ', this.getSelectedItemByValue(this.state.units, this.state.unit).text, '\r\n            '), this.state.showUnitDDL ? React.createElement(DropDown, {
            'selected': this.state.unit,
            'items': this.state.units,
            'onClickOutside': onClickOutside12.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'onSelect': onSelect13.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'onAddNew': this.addNewUnit,
            'addNewItemName': 'Unit',
            'key': '7655'
        }) : null)) : null, React.createElement('div', { 'className': 'feature-creation__aside-footer' }, hasKitchenSub ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.hasVisibility('kitchen', 'enableVisualizer'),
            'text': 'Enable for Kitchen Visualizer',
            'onChecked': onChecked14.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '8176'
        }) : null, hasKitchenSub ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.hasVisibility('kitchen', 'enableQuotingTool'),
            'text': 'Enable for Kitchen Quoting Tool',
            'onChecked': onChecked15.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '8476'
        }) : null, hasBathroomSub ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.hasVisibility('bathroom', 'enableVisualizer'),
            'text': 'Enable for Bathroom Visualizer',
            'onChecked': onChecked16.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '8780'
        }) : null, hasBathroomSub ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.hasVisibility('bathroom', 'enableQuotingTool'),
            'text': 'Enable for Bathroom QuotingTool',
            'onChecked': onChecked17.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '9084'
        }) : null, this.state.showMetaOptions && this.state.forBathroomVisualizer && !hasUnlinkedData ? React.createElement('div', {
            'className': 'feature-creation__aside-footer-sub',
            'key': '9391'
        }, this.state.showMetaCustomComplete ? scopeMultiple19.apply(this, [
            isServerData,
            setStep,
            getLinkClass,
            updateStateValue,
            hasKitchenSub,
            hasBathroomSub,
            hasFireplaceSub,
            hasLaundryRoomSub,
            hasUnlinkedData
        ]) : null, this.state.showMetaFixtureOff ? React.createElement('div', {
            'className': 'feature-creation__aside-footer-sub-group',
            'key': '10203'
        }, React.createElement('div', { 'className': 'feature-creation__aside-footer-sub-group-header' }, 'Fixtures:'), React.createElement(CheckBox, {
            'checked': this.state.metaFixtureOff,
            'text': 'Included with Bathtub',
            'onChecked': onChecked20.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'type': 'tiny'
        })) : null, this.state.showMetaSize ? scopeMultiple22.apply(this, [
            isServerData,
            setStep,
            getLinkClass,
            updateStateValue,
            hasKitchenSub,
            hasBathroomSub,
            hasFireplaceSub,
            hasLaundryRoomSub,
            hasUnlinkedData
        ]) : null) : null, hasFireplaceSub ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.hasVisibility('fireplace', 'enableVisualizer'),
            'text': 'Enable for Fireplace Visualizer',
            'onChecked': onChecked23.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '11399'
        }) : null, hasFireplaceSub ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.hasVisibility('fireplace', 'enableQuotingTool'),
            'text': 'Enable for Fireplace QuotingTool',
            'onChecked': onChecked24.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '11707'
        }) : null, hasLaundryRoomSub ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.hasVisibility('laundryroom', 'enableVisualizer'),
            'text': 'Enable for Laundry Visualizer',
            'onChecked': onChecked25.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '12018'
        }) : null, hasLaundryRoomSub ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.hasVisibility('laundryroom', 'enableQuotingTool'),
            'text': 'Enable for Laundry QuotingTool',
            'onChecked': onChecked26.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '12330'
        }) : null, !hasUnlinkedData ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.hideUnitLabel,
            'text': 'Hide Unit Label',
            'onChecked': onChecked27.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '12645'
        }) : null, !hasUnlinkedData ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.productNotForSale,
            'text': 'Product Not for Sale',
            'onChecked': onChecked28.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '12892'
        }) : null, !hasUnlinkedData ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.employeesOnly,
            'text': 'Enabled for Employees Only',
            'onChecked': onChecked29.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '13152'
        }) : null, !hasUnlinkedData ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.hideQuantity,
            'text': 'Hide Quantity',
            'onChecked': onChecked30.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '13410'
        }) : null, !hasUnlinkedData ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.autoAddToCart,
            'text': 'Automatically Add to Cart',
            'onChecked': onChecked31.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '13653'
        }) : null, !hasUnlinkedData ? React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.notTaxable,
            'text': 'Not Taxable',
            'onChecked': onChecked32.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '13910'
        }) : null, React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.useStonePricing,
            'text': 'Use Stone Pricing (If Available)',
            'onChecked': onChecked33.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        }), React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.priceEditable,
            'text': 'Price Editable',
            'onChecked': onChecked34.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        }), !hasUnlinkedData ? React.createElement('div', {
            'className': 'feature-creation__aside-footer-quantity',
            'key': '14611'
        }, React.createElement('div', {}, 'Default Quantity'), React.createElement('input', {
            'type': 'text',
            'placeholder': '1',
            'className': 'generic-popup-textbox',
            'value': this.state.defaultQuantity,
            'onChange': onChange35.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        })) : null)), React.createElement('div', { 'className': 'feature-creation__content' }, this.state.step.step === Steps.Installation.step && this.state.installations.length === 0 ? React.createElement('div', {
            'className': 'fc-installation fc-installation--empty',
            'key': '15039'
        }, this.state.installations.length ? React.createElement('button', {
            'className': 'fc-installation__button',
            'onClick': this.handleAddInstallation,
            'key': '15215'
        }, '+ Assign Installation') : null, React.createElement('div', {
            'className': 'fc-installation__empty',
            'onClick': this.handleAddInstallation
        }, '\r\n            Assign installation to product by selecting the [+Assign Installation] button to create a new installation\r\n            module and then select the desired installation cost.\r\n          ')) : null, this.state.step.step === Steps.Installation.step && this.state.installations.length > 0 ? React.createElement('div', {
            'className': 'fc-installation',
            'key': '15680'
        }, React.createElement('button', {
            'className': 'fc-installation__button',
            'onClick': this.handleAddInstallation
        }, '+ Assign Installation'), React.createElement.apply(this, [
            'ul',
            { 'className': 'fc-installation__list' },
            _.map(this.state.installations, repeatInstallation40.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData))
        ])) : null, this.state.step.step === Steps.Filters.step ? React.createElement('div', {
            'className': 'fc-filter',
            'key': '17280'
        }, React.createElement('div', { 'className': 'fc-cat' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Filter Categories'), React.createElement.apply(this, [
            'ul',
            { 'className': 'fc-cat__list' },
            _.map(getAvailableFilters(this.props.filterGroups, this.props.group.name, this.props.fabricatorId), repeatItem42.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)),
            !this.props.filterGroups.length ? React.createElement('div', {
                'className': 'ui-loader',
                'key': '18233'
            }) : null
        ])), React.createElement('div', { 'className': 'fc-filters' }, React.createElement('span', { 'className': 'generic-popup-title' }, 'Filters'), !this.state.selectedFilterCategory ? React.createElement('div', { 'key': '18450' }, React.createElement('div', { 'className': 'fc-installation__empty' }, '\r\n                Select a Filter Category\r\n              ')) : null, this.state.selectedFilterCategory ? React.createElement('div', {
            'className': 'fc-filters__search',
            'key': '18648'
        }, React.createElement('input', {
            'type': 'text',
            'className': 'generic-popup-textbox fc-filters__search',
            'placeholder': 'Search filters',
            'value': this.state.searchFiltersText,
            'onChange': onChange43.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        }), this.state.searchFiltersText ? React.createElement('button', {
            'className': 'ui-icon-close ui-icon-close--small fc-filters__search-close',
            'onClick': onClick44.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'key': '19046'
        }) : null) : null, this.state.selectedFilterCategory ? React.createElement.apply(this, [
            'ul',
            {
                'className': 'fc-filters__list',
                'key': '19295'
            },
            _.map(this.getSelectedFilterCategoryValues(), repeatItem46.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData))
        ]) : null)) : null, this.state.step.step == Steps.Gallery.step ? React.createElement('div', {
            'className': 'fc-gallery',
            'key': '19956'
        }, React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.galleryEnabled,
            'text': 'Enable for Image Gallery',
            'onChecked': onChecked47.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        }), this.state.galleryImages.length == 0 ? React.createElement(Dropzone, {
            'accept': 'image/jpeg, image/png, image/svg+xml',
            'onDrop': this.onGalleryDrop,
            'className': 'fc-gallery__upload',
            'acceptStyle': {
                'boxShadow': '0 0 1em green inset',
                'backgroundColor': 'rgba(0,192,0,0.3)'
            },
            'rejectStyle': {
                'boxShadow': '0 0 1em red inset',
                'backgroundColor': 'rgba(192,0,0,0.3)'
            },
            'key': '20299'
        }, React.createElement('div', { 'className': 'fc-gallery__upload-image' }), React.createElement('div', { 'className': 'fc-gallery__upload-text' }, React.createElement('p', {}, 'Drag and Drop Files'), React.createElement('p', {}, 'Supported File Formats: JPG, PNG and SVG')), React.createElement('span', { 'className': 'fc-gallery__upload-browser' }, '+ Select files from Browser')) : null, this.state.galleryImages.length > 0 ? React.createElement.apply(this, [
            'ul',
            {
                'className': 'fc-gallery__list',
                'key': '21089'
            },
            React.createElement('li', { 'className': 'fc-gallery__list-item fc-gallery__list-item-upload' }, React.createElement(Dropzone, {
                'accept': 'image/jpeg, image/png, image/svg+xml',
                'onDrop': this.onGalleryDrop,
                'className': 'fc-gallery__upload',
                'acceptStyle': {
                    'boxShadow': '0 0 1em green inset',
                    'backgroundColor': 'rgba(0,192,0,0.3)'
                },
                'rejectStyle': {
                    'boxShadow': '0 0 1em red inset',
                    'backgroundColor': 'rgba(192,0,0,0.3)'
                }
            }, React.createElement('div', { 'className': 'fc-gallery__upload-image' }), React.createElement('div', { 'className': 'fc-gallery__upload-text' }, React.createElement('p', {}, 'Drag and Drop Files'), React.createElement('p', {}, 'Supported File Formats: JPG, PNG and SVG')), React.createElement('span', { 'className': 'fc-gallery__upload-browser' }, '+ Select files from Browser'))),
            _.map(this.state.galleryImages, repeatImage51.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData))
        ]) : null) : null, this.state.step.step == Steps.ComplexLogic.step ? React.createElement(NewFeatureOverlayComplexLogicStep, {
            'onChange': onChange52.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData),
            'complexLogic': this.state.complexLogic,
            'key': '23123'
        }) : null, this.state.step.step === Steps.DisplayLogic.step && this.props.AR.isSiteAdmin(true) ? React.createElement('div', {
            'className': 'fc-logic fc-logic--display',
            'key': '23456'
        }, React.createElement('div', { 'className': 'fc-logic__header' }, React.createElement('div', { 'className': 'fc-logic__header-left' }, React.createElement(CheckBox, {
            'type': 'tiny',
            'checked': this.state.displayLogicEnabled,
            'text': 'Enable for Quoting Tool',
            'onChecked': onChecked53.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData)
        })), scopeActionText57.apply(this, [
            isServerData,
            setStep,
            getLinkClass,
            updateStateValue,
            hasKitchenSub,
            hasBathroomSub,
            hasFireplaceSub,
            hasLaundryRoomSub,
            hasUnlinkedData
        ])), this.state.displayLogicRules ? React.createElement('button', {
            'className': 'fc-installation__button',
            'onClick': this.handleAddDisplayRule,
            'key': '25108'
        }, '+ Add Display Logic') : null, React.createElement.apply(this, [
            'div',
            { 'className': 'fc-logic__list' },
            _.map(this.state.displayLogicRules, repeatDisplayRule68.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData))
        ])) : null, false && this.props.edit && this.state.step.step === Steps.Layers.step ? React.createElement('div', {
            'className': 'fc-layers',
            'key': '28651'
        }, React.createElement('div', { 'className': 'fc-layers__header' }, React.createElement('div', { 'className': 'fc-layers__header-cell fc-layers__header-cell--title generic-popup-title' }, 'Layer name'), React.createElement('div', { 'className': 'fc-layers__header-cell fc-layers__header-cell--price generic-popup-title' }, 'Price'), React.createElement('div', { 'className': 'fc-layers__header-cell fc-layers__header-cell--checkbox generic-popup-title' }, 'Locked')), React.createElement.apply(this, [
            'ul',
            { 'className': 'fc-layers__list' },
            _.map(this.state.associatedFeatures, repeatAssocFeature71.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData))
        ])) : null, this.state.step.step === Steps.RelatedFeatures.step ? scopeRF83.apply(this, [
            isServerData,
            setStep,
            getLinkClass,
            updateStateValue,
            hasKitchenSub,
            hasBathroomSub,
            hasFireplaceSub,
            hasLaundryRoomSub,
            hasUnlinkedData
        ]) : null, this.props.edit && this.state.step.step === Steps.GroupedFeaturesByName.step && !_.isEmpty(this.state.groupedFeaturesByName) ? React.createElement('div', {
            'className': 'fc-layers',
            'key': '35838'
        }, React.createElement('div', { 'className': 'fc-layers__header' }, React.createElement('div', { 'className': 'fc-layers__header-cell fc-layers__header-cell--title generic-popup-title' }, 'Feature Name'), React.createElement('div', { 'className': 'fc-layers__header-cell fc-layers__header-cell--price generic-popup-title' }, 'Price'), React.createElement('div', { 'className': 'fc-layers__header-cell fc-layers__header-cell--checkbox generic-popup-title' }, 'Locked')), React.createElement.apply(this, [
            'ul',
            { 'className': 'fc-layers__list' },
            _.map(this.state.groupedFeaturesByName, repeatFeature86.bind(this, isServerData, setStep, getLinkClass, updateStateValue, hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasUnlinkedData))
        ])) : null, this.state.step.step === Steps.BundledFeatures.step ? React.createElement(NewFeatureOverlayBundledFeaturesStep, {
            'newFeatureOverlay': this,
            'unfilteredFeatureGroups': this.props.unfilteredFeatureGroups,
            'bundledFeatures': this.state.bundledFeatures,
            'key': '37490'
        }) : null))), scopeCanSaveCanNextCanBack90.apply(this, [
            isServerData,
            setStep,
            getLinkClass,
            updateStateValue,
            hasKitchenSub,
            hasBathroomSub,
            hasFireplaceSub,
            hasLaundryRoomSub,
            hasUnlinkedData
        ]));
    }
    return scopeIsServerDataSetStepGetLinkClassUpdateStateValueHasKitchenSubHasBathroomSubHasFireplaceSubHasLaundryRoomSubHasUnlinkedData91.apply(this, []);
}